<div class="min-h-full bg-secondary-100 lg:pb-8 overflow-hidden h-full-minus-navigation-height">
  <div class="overflow-auto max-h-full mt-header-border-radius h-full-minus-header-border-radius">
    <div class="pb-navigation-total lg:pb-0">
      <app-container>
        <div class="py-4 font-primary">
          <h1 class="hidden lg:block font-secondary text-2xl font-bold">
            Privacy policy
          </h1>
          <p class="lg:mt-2">
            Toeristisch-recreatief platform Peel en Maas, gevestigd aan Kerkstraat 24 5768BG Meijel, is verantwoordelijk voor de verwerking van persoonsgegevens zoals
            weergegeven in deze privacyverklaring.
          </p>
          <div class="mt-4">
            <p>
              <strong>Contactgegevens:</strong>
            </p>
            <a href="https://opgoeiegrond.nl" class="text-blue-700">https://www.opgoeiegrond.nl</a>
            <address>Kerkstraat 24 5768BG Meijel</address>
            <a href="tel:0854841200" class="text-blue-700">085 484 1200</a>
          </div>
          <div class="py-4">
            <h2 class="font-secondary text-xl font-bold">
              Persoonsgegevens die wij verwerken
            </h2>
            <p>
              Toeristisch-recreatief platform Peel en Maas verwerkt geen persoonsgegevens omdat op onze site geen persoonsgegevens achter gelaten kunnen worden. Ook
              gebruiken we geen social media plugins.
              <br>
              Wij kunnen uw locatie vragen om u een preciezere locatie op de kaart de tonen. Deze gegevens slaan wij nergens op en worden enkel gebruikt voor de functionaliteit van de kaart.
            </p>
          </div>
          <div class="py-4">
            <h2 class="font-secondary text-xl font-bold">
              Cookies
            </h2>
            <p>
              Deze website maakt gebruik van verschillende soorten cookies. Voor sommige soorten hebben we je toestemming nodig.<br><br>
              De noodzakelijke cookies en anonieme statistieken zijn altijd automatisch actief. Om je cookie instellingen aan te passen, klik je op “Cookie instellingen”.
            </p>
            <button class="inline-flex w-auto items-center space-x-2 mt-4 bg-primary-700 text-white font-medium p-2 px-4 rounded-full"
                    (click)="openCookieConsentModal()">Cookie instellingen</button>
          </div>
        </div>
      </app-container>
    </div>
  </div>
</div>
